import React from 'react';

const SortableColumn = ({column, handleSort, order, orderBy, children, styles, classes}) => {
    return (
        <th
            className={`${classes} text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${orderBy === column ? styles.selectedColumn : ''}`}
            onClick={() => handleSort(column)}
        >
            {children}
        </th>

    )
}

export default SortableColumn;